import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "rs-toolbar-item",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class ToolbarItemComponent {
  @Input("image") image: string;
  @Input("text") text: string;
  @Input("disabled") disabled: boolean;
  @Input("children") children: any[] = [];
  @Input("hideArrow") hideArrow: boolean = false;
  @Input() disabledOptions: { [key: string]: any } = {};

  @ViewChild("buttonElement", { static: false }) buttonElement!: ElementRef;
  @HostBinding("class.disabled") get hostDisabled() {
    return !!this.disabled;
  }

  // 暴露方法供父组件调用
  getWidth(): number {
    return this.buttonElement.nativeElement.offsetWidth;
  }

  ImageType = [
    "Add",
    "Delete",
    "Update",
    "Import",
    "Export",
    "Upload",
    "Download",
    "Duplicate",
    "Refresh",
    "AddFolder",
    "Collapse",
    "Combine",
    "Edit",
    "Lock",
    "Expand",
    "MoveTo",
    "Publish",
    "Preview",
    "ReCalculate",
    "Sync",
    "Share",
    "Rename",
    "SaveSequence",
    "SubmitForApproval",
    "SendToControlPanel",
    "SetReminders",
    "Settle",
    "Template",
    "Workflow",
    "FetchData",
  ];
}
